export default __webpack_public_path__ + "static/media/print.ad6ce89d.svg";